module.exports = __webpack_public_path__ + "static/media/quiz-hint-2-video-thumbnail.87f9d227.jpg";